<div class="img-ul-container">
  @for (file of files; track file) {
    <div
      class="img-ul-image"
      [ngStyle]="{ 'background-image': 'url(' + file.src + ')' }">
      @if (file.pending) {
        <div class="img-ul-loading-overlay">
          <div class="img-ul-spinning-circle"></div>
        </div>
      }
    </div>
  }
</div>

<div class="img-ul-file-upload position-absolute">
  <label class="button fab">
    <span class="icons-sprite tiny pencil"></span>
    <input
      type="file"
      [accept]="supportedExtensions"
      (change)="onFileChange(input.files)"
      #input />
  </label>
</div>
